import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../../app/state/app.selectors';
import * as fromExpOrg from './exp-org.reducers';

export interface ExpOrgState {
  stateData: fromExpOrg.State;
}

export interface State extends fromRoot.AppState {
  expOrg: ExpOrgState;
}

export const reducers = {
  stateData: fromExpOrg.reducer
};

export const selectExpOrgState = createFeatureSelector<ExpOrgState>('expOrg');

export const selectExpOrgStateData = createSelector(selectExpOrgState, (state: ExpOrgState) => state.stateData);

export const getExpOrgState = createSelector(selectExpOrgStateData, fromExpOrg.getStateData);

export const getExpOrgScreenError = createSelector(selectExpOrgStateData, fromExpOrg.getError);

export const getExpOrgScreenPending = createSelector(selectExpOrgStateData, fromExpOrg.getPending);